import { useState } from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { buildWebpageUrl } from 'modules/core/lib/buildUrl'

const localeToSectionMap: { [key: string]: string } = {
  es: 'ES',
  it: 'UK',
  fr: 'FR',
  de: 'DE',
  pt: 'PT',
  en: 'UK',
  'en-gb': 'UK',
  'pt-br': 'BR',
  'es-mx': 'LTM',
  'es-ar': 'LTM',
  'es-cl': 'LTM',
  'es-co': 'LTM',
}

export type Media = {
  hashed_id: string
  name: string
  thumbnail: { url: string }
  duration: number
  section: string
}

type ModalStates = {
  isLoading: boolean
  isError: boolean
  data: never[]
}

const useFetchVideos = () => {
  const {
    access: { locale },
  } = useCurrentSession()
  const [modalStates, setModalStates] = useState({
    isLoading: true,
    isError: false,
    data: [],
  })

  const section = localeToSectionMap[locale] || localeToSectionMap.en

  const fetchVideos = async () => {
    const fetchUrl = buildWebpageUrl('/api/wistia')
    return fetch(fetchUrl, {}).then((res) => res.json())
  }

  const handleStateChange = (state: Partial<ModalStates>) => {
    setModalStates((prevState) => ({
      ...prevState,
      ...state,
    }))
  }

  useEffect(() => {
    fetchVideos().then(({ success, data }) => {
      if (success) {
        const medias = data.medias.filter((media: Media) => media.section === section)
        handleStateChange({ data: medias, isLoading: false })
      } else {
        handleStateChange({ isError: true, isLoading: false })
      }
    })
  }, [section])

  return { isLoading: modalStates.isLoading, isError: modalStates.isError, data: modalStates.data }
}

export default useFetchVideos
